import { Actor, Engine, Label, vec } from "excalibur";
import { Plant, PlantType } from "./plant";

export class PlantCollection extends Actor {
  protected knownPlants: Set<PlantType> = new Set();

  protected total: Label = new Label({
    text: "0/30",
  });

  get Size() {
    return this.knownPlants.size;
  }

  constructor() {
    super({
      name: "PlantCollection",
    });
  }

  override onInitialize(engine: Engine): void {
    super.onInitialize(engine);
    this.total.pos = vec(20, 20);
    this.addChild(this.total);
  }

  public addPlant(plant: PlantType) {
    if (this.knownPlants.has(plant)) {
      return;
    }
    this.knownPlants.add(plant);
    // You can use
    const x = 800 - (((this.knownPlants.size - 1) % 15) + 1) * 36;
    this.addChild(
      new Plant(plant, vec(x, this.knownPlants.size > 15 ? 54 : 18), false)
    );
    this.total.text = `${this.knownPlants.size}/30`;
  }
}
